// safeguard against legacy browsers failing from any stray console calls in our output...
if (typeof window.console === 'undefined') {
    window.console = {};
    var types = ['log', 'warn', 'dir', 'info', 'debug'];
    for (var i = 0; i < types.length; i++) {
        window.console[types[i]] = function(){ return false; }
    }
}
